export default {
  navbar: {
    home: '首页',
    jobs: '工作',
    companies: '公司',
    about: '关于我们',
    customerService: '联系客服',
    signIn: '登录',
    register: '注册'
  },
  customerService: {
    title: '联系客服',
    subtitle: '我们的专业支持团队随时为您服务，24/7 在线解答您的问题。',
    onlineService: '在线服务',
    serviceDescription: '我们的专业支持团队随时为您服务，24/7',
    startChat: '开始在线聊天',
    responseTime: '平均响应时间：30秒',
    instantResponse: '即时响应',
    instantResponseDesc: '我们的客服团队全天候在线，平均响应时间不超过2分钟',
    professionalTeam: '专业团队',
    professionalTeamDesc: '经过严格培训的客服人员，熟悉各项业务流程',
    securityPrivacy: '安全保密',
    securityPrivacyDesc: '您的所有信息都经过加密处理，确保绝对安全',
    serviceOnline: '服务在线',
    seniorConsultant: '高级客户顾问'
  },
  home: {
    heroTitle: '寻找电影行业的理想工作',
    heroSubtitle: '与顶级电影院和娱乐公司建立联系。今天就开始您在令人兴奋的电影世界中的旅程。',
    popularCategories: '热门工作类别',
    categoriesDescription: '探索各种电影和娱乐领域的机会',
    featuredJobOpportunities: '精选工作机会',
    discoverLatestOpenings: '发现顶级影院的最新空缺职位',
    openPositions: '个空缺职位',
    quickApply: '快速申请',
    whyChooseUs: '为什么选择我们',
    joinLargestNetwork: '加入最大的电影专业人士网络',
    categories: {
      theaterOperations: {
        title: '影院运营',
        description: '管理日常影院运营，确保演出顺利进行'
      },
      boxOfficeManagement: {
        title: '票房管理',
        description: '处理票房售票和客户服务'
      },
      cinemaTechnology: {
        title: '影院技术',
        description: '维护和操作先进的影院设备和系统'
      },
      customerService: {
        title: '客户服务',
        description: '为影院观众提供卓越服务'
      },
      foodBeverage: {
        title: '餐饮服务',
        description: '管理小卖部和食品服务运营'
      },
      marketingPromotions: {
        title: '营销与推广',
        description: '为影院创建和执行营销策略'
      }
    },
    featuredJobs: {
      theaterManager: {
        title: '影院经理',
        company: 'AMC影院',
        location: '纽约，NY',
        type: '全职',
        salary: '$65K - $85K',
        benefit: '福利'
      },
      digitalProjectionist: {
        title: '数字放映师',
        company: 'Regal影院',
        location: '洛杉矶，CA',
        type: '全职',
        salary: '$45K - $60K',
        benefit: '培训'
      },
      marketingCoordinator: {
        title: '营销协调员',
        company: 'Cinemark',
        location: '芝加哥，IL',
        type: '全职',
        salary: '$50K - $65K',
        benefit: '远程'
      }
    },
    features: {
      largeIndustryNetwork: {
        title: '庞大的行业网络',
        description: '与全球2,500多家影院和娱乐公司建立联系',
        stat: '15,000+ 活跃用户'
      },
      verifiedEmployers: {
        title: '验证过的雇主',
        description: '所有雇主都经过严格审查，确保机会真实可信',
        stat: '100% 验证公司'
      },
      careerGrowth: {
        title: '职业发展',
        description: '获得培训资源和晋升机会',
        stat: '89% 成功率'
      }
    }
  },
  jobs: {
    heroTitle: '加入我们的电影大家庭',
    heroSubtitle: '成为将故事变为现实的魔力的一部分。我们正在寻找充满激情的个人加入我们不断成长的团队。',
    viewPositions: '查看开放职位',
    currentOpenings: '当前开放职位',
    department: '部门',
    location: '地点',
    applyNow: '立即申请',
    whyJoinUs: '为什么加入我们',
    ourCulture: '我们的文化',
    applicationProcess: '申请流程',
    startYourJourney: '开始您的旅程',
    benefits: {
      freeMovieAccess: {
        title: '免费电影',
        description: '您和家人可享受无限免费电影。'
      },
      careerGrowth: {
        title: '职业发展',
        description: '全面的培训和清晰的职业发展路径。'
      },
      flexibleSchedule: {
        title: '灵活排班',
        description: '灵活的排班选项，实现工作与生活的平衡。'
      }
    },
    jobList: [
      {
        title: '影院运营经理',
        location: '纽约，NY',
        type: '全职',
        description: '领导日常影院运营，确保我们的旗舰店提供卓越的客户体验。'
      },
      {
        title: '高级放映师',
        location: '洛杉矶，CA',
        type: '全职',
        description: '操作和维护数字放映系统，确保最佳观影体验。'
      },
      {
        title: '小卖部团队领导',
        location: '芝加哥，IL',
        type: '全职',
        description: '管理小卖部运营，领导食品服务专业团队。'
      },
      {
        title: '客户体验专员',
        location: '迈阿密，FL',
        type: '兼职',
        description: '提供卓越服务，为我们的客人创造难忘的体验。'
      },
      {
        title: '技术支持专家',
        location: '西雅图，WA',
        type: '全职',
        description: '维护和排查影院设备和系统。'
      },
      {
        title: '活动协调员',
        location: '波士顿，MA',
        type: '全职',
        description: '策划和执行特别放映和私人影院活动。'
      }
    ],
    testimonials: [
      {
        name: '艾米丽·理查森',
        position: '影院经理',
        quote: '在这里工作是一次不可思议的旅程。成长机会和支持性环境让这里不仅仅是一份工作。'
      },
      {
        name: '迈克尔·安德森',
        position: '高级放映师',
        quote: '我们使用的技术和设备是最先进的。对于任何电影爱好者来说，这都是梦想成真。'
      },
      {
        name: '莎拉·马丁内斯',
        position: '活动协调员',
        quote: '这里的团队精神令人惊叹。我们共同努力为客人创造难忘的体验。'
      }
    ],
    applicationSteps: [
      {
        title: '在线申请',
        description: '通过我们的职业门户提交申请。'
      },
      {
        title: '初步审核',
        description: '我们的团队将在48小时内审核您的申请。'
      },
      {
        title: '面试',
        description: '与我们的团队会面，讨论这个机会。'
      },
      {
        title: '欢迎加入',
        description: '开始您与我们电影大家庭的旅程。'
      }
    ]
  },
  companies: {
    searchPlaceholder: '搜索公司...',
    location: '地点',
    companySize: '公司规模',
    industry: '行业',
    openPositions: '个空缺职位',
    viewJobs: '查看职位',
    loadMore: '加载更多公司',
    companyList: [
      {
        name: '环球娱乐集团',
        location: '洛杉矶，CA',
        size: '5,000+ 员工',
        description: '领先的全球娱乐公司，在全球制作和发行电影和电视内容。'
      },
      {
        name: 'Cinemark制作公司',
        location: '纽约，NY',
        size: '2,000-5,000 员工',
        description: '屡获殊荣的制作工作室，专注于大片电影和创新数字内容。'
      },
      {
        name: '数字影院解决方案',
        location: '旧金山，CA',
        size: '1,000-2,000 员工',
        description: '科技驱动的公司，通过创新解决方案革新数字影院体验。'
      },
      {
        name: '派拉蒙数字工作室',
        location: '芝加哥，IL',
        size: '500-1,000 员工',
        description: '通过前沿技术创造下一代数字娱乐体验。'
      },
      {
        name: '全球影院网络',
        location: '迈阿密，FL',
        size: '1,000-2,000 员工',
        description: '在主要城市经营拥有最先进设施的高端影院连锁。'
      },
      {
        name: '银幕科技',
        location: '西雅图，WA',
        size: '500-1,000 员工',
        description: '为现代影院行业开发前沿软件解决方案。'
      }
    ]
  },
  about: {
    heroTitle: '关于我们',
    heroSubtitle: '在创意与科技交汇之处，故事通过创新的镜头化为现实。',
    ourStory: '我们的故事',
    storyParagraph1: 'CineMaster Studio 成立于2010年，十多年来一直处于电影创新的前沿。我们的旅程始于一个简单而强大的愿景：创作能够引起全球观众共鸣的引人入胜的视觉故事。',
    storyParagraph2: '今天，我们很自豪能成为领先的制作工作室之一，与全球品牌和行业内的才华艺术家合作。我们对卓越的承诺和对讲故事的热情继续推动我们前进。',
    ourCoreValues: '我们的核心价值观',
    creativeExcellence: '创意卓越',
    creativeExcellenceDesc: '突破边界，在视觉叙事中设定新标准。',
    collaborativeSpirit: '协作精神',
    collaborativeSpiritDesc: '共同努力，将独特的愿景变为现实。',
    qualityFirst: '质量第一',
    qualityFirstDesc: '在我们创作的每一帧中追求卓越。',
    meetOurTeam: '认识我们的团队',
    creativeDirector: '创意总监',
    leadCinematographer: '首席摄影师',
    technicalDirector: '技术总监',
    productionManager: '制作经理',
    yearsExperience: '年经验',
    projectsCompleted: '完成项目',
    industryAwards: '行业奖项',
    happyClients: '满意客户'
  },
  footer: {
    copyright: '© 2025 TJH - Ticket Job Hub. 保留所有权利。',
    description: '连接电影行业的人才与机遇。找到您在影院运营、管理或技术职位的下一个角色。',
    quickLinks: '快速链接',
    jobSeeker: '求职者',
    newsletter: '新闻通讯',
    newsletterText: '订阅以获取最新的职位更新和职业建议。',
    emailPlaceholder: '您的邮箱',
    subscribe: '订阅',
    quickLinksList: ['关于我们', '联系我们', '隐私政策', '服务条款'],
    jobSeekerLinksList: ['浏览职位', '职业资源', '简历技巧', '职位提醒']
  }
}